import axios from 'axios';
import {
  EVENTS_LOAD_EVENT_DETAIL_BEGIN,
  EVENTS_LOAD_EVENT_DETAIL_SUCCESS,
  EVENTS_LOAD_EVENT_DETAIL_FAILURE,
  EVENTS_LOAD_EVENT_DETAIL_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadEventDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_LOAD_EVENT_DETAIL_BEGIN,
    });
    const { projectId, eventId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_LOAD_EVENT_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_LOAD_EVENT_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEventDetailError() {
  return {
    type: EVENTS_LOAD_EVENT_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_EVENT_DETAIL_BEGIN:
      return {
        ...state,
        loadEventDetailPending: true,
        loadEventDetailError: null,
      };

    case EVENTS_LOAD_EVENT_DETAIL_SUCCESS:
      return {
        ...state,
        loadEventDetailPending: false,
        loadEventDetailError: null,
        selectedEvent: action.data,
      };

    case EVENTS_LOAD_EVENT_DETAIL_FAILURE:
      return {
        ...state,
        loadEventDetailPending: false,
        loadEventDetailError: action.data.error,
      };

    case EVENTS_LOAD_EVENT_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadEventDetailError: null,
      };

    default:
      return state;
  }
}
